import React, { ReactNode } from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'

import './utils/setup'

interface ChartWrapperProps {
  children: ReactNode
  flexItem?: boolean
  sx?: SxProps
}

const ChartWrapper = (props: ChartWrapperProps) => {
  const { children, flexItem, sx } = props

  if (flexItem) {
    return (
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          minWidth: 0,
          position: 'relative',
          ...sx
        }}
      >
        <Box
          sx={{
            height: '100%',
            position: 'relative',
            width: '100%',
            '& canvas': {
              display: 'block',
              height: '100% !important',
              maxHeight: '100% !important',
              maxWidth: '100% !important',
              width: '100% !important'
            }
          }}
        >
          {children}
        </Box>
      </Box>
    )
  }

  return <>{children}</>
}

export default ChartWrapper
